import {
  AVATAR_COLORS_BRIGHT,
  AVATAR_COLORS_SOFT,
  AvatarColor,
} from "../data/avatar-colores.data";

export function getRandomColor(
  type: "bright" | "soft" | "any" = "any"
): AvatarColor {
  let palette: AvatarColor[];

  switch (type) {
    case "bright":
      palette = AVATAR_COLORS_BRIGHT;
      break;
    case "soft":
      palette = AVATAR_COLORS_SOFT;
      break;
    default:
      palette = [...AVATAR_COLORS_BRIGHT, ...AVATAR_COLORS_SOFT];
  }

  const index = Math.floor(Math.random() * palette.length);
  return palette[index];
}

export function getAvatarColorByKey(
  key: string,
  type: "bright" | "soft" | "any" = "any"
): AvatarColor {
  let palette: AvatarColor[];

  switch (type) {
    case "bright":
      palette = AVATAR_COLORS_BRIGHT;
      break;
    case "soft":
      palette = AVATAR_COLORS_SOFT;
      break;
    default:
      palette = [...AVATAR_COLORS_BRIGHT, ...AVATAR_COLORS_SOFT];
  }

  const hash = Array.from(key).reduce(
    (acc, char) => acc + char.charCodeAt(0),
    0
  );
  const index = hash % palette.length;
  return palette[index];
}
